import { Table, TableBody, TableCell, TableFooter, TableRow } from "@material-ui/core";
import { calculateQuarterly, calculateYearly } from "../../helpers";
import { BlackCellBorderWhite, BrightYellowCell, LightYellowCell, StyledTableRow } from "../Page/TableStyles";

export default function YourSystemTable(props) {
    const {formData, dailyProduction, sunHours} = props;

    return (
        <Table size='small'>
            <TableBody>
                <StyledTableRow>
                    <BlackCellBorderWhite>Your System</BlackCellBorderWhite>
                </StyledTableRow>
                <StyledTableRow>
                    <BlackCellBorderWhite>System Size</BlackCellBorderWhite>
                    <BlackCellBorderWhite>Production Average</BlackCellBorderWhite>
                    <BlackCellBorderWhite>KWH Daily</BlackCellBorderWhite>
                    <BlackCellBorderWhite>KWH Quarterly</BlackCellBorderWhite>
                    <BlackCellBorderWhite>KWH Annually</BlackCellBorderWhite>
                    <BlackCellBorderWhite>Loss Factor</BlackCellBorderWhite>
                </StyledTableRow>
                <StyledTableRow>
                    <LightYellowCell>{formData.systemSize} kW</LightYellowCell>
                    <LightYellowCell>{sunHours[formData.officeName]}</LightYellowCell>
                    <LightYellowCell>{dailyProduction}</LightYellowCell>
                    <LightYellowCell>{Math.round(dailyProduction * 365 / 4)}</LightYellowCell>
                    <LightYellowCell>{Math.round(dailyProduction* 365)}</LightYellowCell>
                    <BrightYellowCell>{formData.systemLossFactor}%</BrightYellowCell>
                </StyledTableRow>
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell colSpan={6}>
                        Easy Solar Tip, For every 1 Kw installed on your roof, your system will produce REPLACEME_kW on average across a 12 month period, daily production = system size x Production average
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>
    )
}